module.exports = __webpack_public_path__ + "img/sneaker-collect.c8f1bb9f.png";